// app-service may write a naive ISO-8601 whose instant is UTC by convention, so a value without an
// offset is pinned to `Z` before parsing — `new Date()` would otherwise read it in the browser's
// zone (ADR 0011). Same rule as the exclusion lists' «Desde».
const HAS_OFFSET = /(?:Z|[+-]\d{2}:?\d{2})$/i;

// A batch has no «buzón» to borrow a zone from, so the host hands in the panel's own; `null` renders
// in UTC rather than guessing. `Intl` throws on an unknown zone, and the raw string is a better
// answer than a crash in a render.
export function formatDateTime(iso: string, timeZone: string | null): string {
  const date = new Date(HAS_OFFSET.test(iso) ? iso : `${iso}Z`);
  if (Number.isNaN(date.getTime())) return iso;
  try {
    const parts = new Intl.DateTimeFormat('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23',
      timeZone: timeZone ?? 'UTC',
    }).formatToParts(date);
    const part = (type: Intl.DateTimeFormatPartTypes) =>
      parts.find((candidate) => candidate.type === type)?.value ?? '';
    return `${part('day')}/${part('month')}/${part('year')} ${part('hour')}:${part('minute')}`;
  } catch {
    return iso;
  }
}

// Thousands grouped with a dot from four digits on. Written out rather than `Intl`: es-ES leaves a
// four-digit number ungrouped, and a column where «1234» sits above «12.345» reads as two formats.
export function formatCount(value: number): string {
  const sign = value < 0 ? '-' : '';
  return `${sign}${Math.trunc(Math.abs(value)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
}

export function formatPercentage(value: number): string {
  const rounded = Math.round(value * 10) / 10;
  return `${rounded.toString().replace('.', ',')} %`;
}
